import { config } from '../config';
import { saveAs } from 'file-saver';
import i18n from 'i18next';
import en from '../localization/en';
import fi from '../localization/fi';

// Initialize i18n
i18n.init({
  fallbackLng: 'en',
  debug: false,
  resources: {
    en,
    fi,
  },
  supportedLngs: ['en', 'fi'],
});

interface DownloadDocumentsParams {
  accessToken: string;
  organizationId: string;
  threadIds: string[];
  fileSuffix: string;
  plural: boolean;
  setLoading?: (loading: boolean) => void;
}

export class DocumentDownloader {
  public static async downloadDocuments({
    accessToken,
    organizationId,
    threadIds,
    fileSuffix,
    plural,
    setLoading,
  }: DownloadDocumentsParams): Promise<void> {

    if (!fileSuffix) {
      throw new Error('Invalid request. fileSuffix is required.');
    }

    if (!Array.isArray(threadIds)) {
      throw new Error('Invalid request. threadIds must be an array.');
    }

    if (setLoading) setLoading(true);
    try {
      const response = await fetch(
        config.endpoints.downloadDocuments,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'X-Organization': organizationId,
          },
          body: JSON.stringify({ threadIds }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const filename = `${i18n.t(`receipt${plural ? 's' : ''}`)}_${fileSuffix}.zip`;
      const blob = await response.blob();
      saveAs(blob, filename);
    } finally {
      if (setLoading) setLoading(false);
    }
  }
}